import { createFileRoute } from '@tanstack/react-router';
import { JourneysTransactionalSetupHandoff } from '@/pages/workspaces/transactional/message/setup/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/setup',
)({
  component: JourneysTransactionalSetupHandoff,
});
